import React, { Component } from 'react';
import avatar from "../img/avatar.jpg";
import memoji from "../img/memoji.png";
import resume from "../my resume.pdf"

class SectionThree extends Component {
    state = {  }
    render() { 
        return ( 
            <div className="sectionThree" path="sectionThree" id="about">
                <h4>—ABOUT ME</h4>
                <div className="aboutMe">
                    
                    <img src={memoji} alt="" className="img"/>
                
                    <p className="aboutText">
                        <h3>Hello👋🏿,I'm Adedigba Adedotun</h3><br/>
                        <p>An aspiring Software Engineer who wants to help the world in his own little way,
                            I'm a Computer Science undergrad(Bachelor of Science) student in the University of Benin, <br/> I'm currently in search
                            for a Junior Front-end Developer role or an internship(availabe for remote),
                            I contribute to tech communities and I'm a core member of some tech 
                            communities in my University,<br/> I'm interested in Web/Mobile Engineering but I currently
                            major in Web Front-End development.<br/>I am a lover of the Blockchain technology and
                            would like to invest in cryptocurrencies someday. Outside my tech world, I play the lead guitar as a hobby.
                            View and Download my <a className="resume" href={resume} download>Resumé</a>
                        </p>
                     

                        <h3 className="skill_header">SKILLSET</h3>
                        <ul className="skill_list">
                            <li>HTML</li>
                            <li>CSS</li>
                            <li>SASS/SCSS</li>
                            <li>JavaScript</li>
                            <li>ReactJS</li>
                            <li>Bootstrap</li>
                            <li>NPM</li>
                            <li>git</li>
                        </ul>

                    </p>
                </div>

                <div className="contact-box">
                    <div className="contact-email">
                        <h5>EMAIL📧</h5>
                        <a href="mailto:adedigbaadedotunemmanuel@gmail.com" className='contact_link'>adedigbaadedotunemmanuel@gmail.com</a>
                    </div>

                    <div className="contact-phone">
                        <h5>PHONE📲</h5>
                        <a href="tel:08145012271" className='contact_link'>(+234)8145012271</a>
                    </div>
                </div>

                <div className="footer">
                    <h4>&copy;2021, Developed and maintained with 💛 by Adedigba Adedotun.</h4>
                </div>
            </div>
        );
    }
}
 
export default SectionThree;